module.exports = "<rb-menu></rb-menu>\n<router-outlet></router-outlet>\n<rb-footer></rb-footer>\n"